/**
 * Fotos vor dem Hochladen verkleinern (F20): längste Kante 1600 px, JPEG 0,8.
 * Ein Handyfoto schrumpft so von 4–8 MB auf rund 300–500 KB – entscheidend im
 * Hallen-WLAN. Ohne Abhängigkeiten, nur `createImageBitmap` und Canvas.
 * Der Server kodiert ohnehin neu und entfernt EXIF/GPS.
 */
const MAX_EDGE = 1600;

export async function resizePhoto(file: File): Promise<Blob> {
  if (!file.type.startsWith('image/') || /heic|heif/i.test(file.type)) return file;
  try {
    const bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' });
    const scale = Math.min(1, MAX_EDGE / Math.max(bitmap.width, bitmap.height));
    const width = Math.round(bitmap.width * scale);
    const height = Math.round(bitmap.height * scale);
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    if (!ctx) return file;
    ctx.drawImage(bitmap, 0, 0, width, height);
    bitmap.close();
    const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, 'image/jpeg', 0.8));
    return blob ?? file;
  } catch {
    // Älterer Browser oder unlesbares Format: Original schicken, der Server prüft.
    return file;
  }
}
